import { Trans } from 'react-i18next';
import EventIcon from '@mui/icons-material/Event';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import { Alert } from '@components/Alert';
import { ROUTES } from '@routes/routes';
import { NotificationPresenter } from '@notifications/interfaces';
import { translate } from '@translations/i18n';
import { CompetitionSessionTomorrowReminderNotificationData } from './interfaces';

const isCompetitionSessionTomorrowReminderPayload = (
  payload: unknown
): payload is CompetitionSessionTomorrowReminderNotificationData => {
  if (typeof payload !== 'object' || payload === null) {
    return false;
  }

  return (
    'competitionName' in payload &&
    typeof payload.competitionName === 'string'
  );
};

export const competitionSessionTomorrowReminderPresenter: NotificationPresenter<CompetitionSessionTomorrowReminderNotificationData> =
  {
    type: 'competition-session-tomorrow-reminder',
    icon: EmojiEventsIcon,
    badgeIcon: EventIcon,
    isPayload: isCompetitionSessionTomorrowReminderPayload,
    label: (payload, t) =>
      t('notifications:types.competition-session-tomorrow-reminder', {
        competitionName: payload.competitionName,
      }),
    message: (payload) => (
      <Trans
        i18nKey="notifications:menu.competition-session-tomorrow-reminder"
        values={{
          competitionName: payload.competitionName,
        }}
        components={{
          bold: <strong />,
        }}
      />
    ),
    body: () => (
      <Alert
        severity="info"
        content={translate(
          'notifications:body.competition-session-tomorrow-reminder'
        )}
      />
    ),
    path: (payload) => {
      if (!payload.competitionSlug) {
        return null;
      }

      return `${ROUTES.manage.competitions.details(payload.competitionSlug)}?tab=sessions`;
    },
  };
